import * as z from "zod";
import {
  HeatingTypeId,
  JointBillServiceTypeId,
} from "@services/jointBillServices/types";

export const useHouseDetailsSchema = (
  jointBillServiceTypeIdFieldName: string,
  areaFieldName: string,
  heatingTypeIdFieldName: string,
) => {
  return z.object({
    [jointBillServiceTypeIdFieldName]: z.optional(
      z.nativeEnum(JointBillServiceTypeId),
    ),
    [areaFieldName]: z.optional(z.string()),
    [heatingTypeIdFieldName]: z.optional(z.nativeEnum(HeatingTypeId)),
  });
};
